import { useContext } from 'react';
import { BrandingContext } from '@/contexts/branding/branding-context';

export const useBranding = () => useContext(BrandingContext);
